<template>
    <div class="transaction-list" v-if="currentComponent">
        <el-card>
            <component
                :is="currentComponent"
                ref="transactionListComponent"
                :filters="filters"
                @refresh-loan-totalizers="$emit('refresh-loan-totalizers')"
            />
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'warehouseTransactionList',
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data() {
        return {
            components: {
                PY: () =>
                    import(
                        '@/modules/warehouse/views/pages/viewWarehouse/components/transaction-list/py.vue'
                    )
            }
        };
    },
    mounted() {
    },
    computed: {
        currentComponent() {
            this.$emit('input', []);
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    },
    watch: {
    },
    methods: {
    }
};
</script>

<style scoped lang="scss">
.transaction-list {
    margin-top: 24px;
}
</style>
